<template>
  <v-app>
    <v-content>
      <Main/>
    </v-content>
  </v-app>
</template>

<script>
import Main from "./components/Main";

export default {
  name: "App",
  components: {
    Main
  },
  data() {
    return {
      //
    };
  }
};
</script>

<style>
body {
  background-color: #eee;
  font-family: helvetica, arial;
}

#logo {
  text-align: center;
}

#who {
  text-align: center;
  opacity: 0;
  animation: 0.5s show linear forwards;
  animation-delay: 1.8s;
  margin: 0 auto;
  width: 320px;
  height: 60px;
}

#who:hover .shape {
  animation: 0.5s draw linear forwards;
}

#who div {
  color: #777;
  font-weight: 500;
  font-family: helvetica, arial;
  font-size: 22px;
  letter-spacing: 7px;
  line-height: 38px;
  position: relative;
  top: -53px;
  left: 3px;
  cursor: pointer;
  user-select: none;
}
#robert {
  color: #777;
  font-family: helvetica, arial;
  font-size: 20px;
  text-align: center;
}

#links {
  opacity: 0;
  transition: opacity 0.8s;
}

#links.show {
  opacity: 1;
}

#robert .section {
  opacity: 0;
  transition: opacity 0.8s;
}

#robert .section.active {
  opacity: 1;
}

#robert-animation path {
  stroke: #666;
  fill: none;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}

#robert-animation path#face {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}

#robert-animation path#face.animate {
  animation: dash 2s linear forwards;
}

#robert-animation path#mouth {
  stroke-width: 3;
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#mouth.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 1.2s;
}

#robert-animation path#left-eye {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#left-eye.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 2s;
}

#robert-animation path#right-eye {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#right-eye.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 2.5s;
}

#robert-animation path#right-foot {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#right-foot.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 3s;
}

#robert-animation path#left-foot {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#left-foot.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 3.5s;
}

#robert-animation path#right-arm {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#right-arm.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 4s;
}

#robert-animation path#right-hand {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
}

#robert-animation path#right-hand.animate {
  animation: dash 1s linear forwards;
  animation-delay: 4.5s;
}

#robert-animation path#left-arm {
  stroke-dasharray: 87;
  stroke-dashoffset: 87;
}

#robert-animation path#left-arm.animate {
  animation: dash 0.5s linear forwards;
  animation-delay: 5.8s;
}

#robert-animation path#left-hand {
  stroke-dasharray: 110;
  stroke-dashoffset: 110;
}

#robert-animation path#left-hand.animate {
  animation: dash 1s linear forwards;
  animation-delay: 6.3s;
}

.shape {
  fill: transparent;
  stroke-dasharray: 180 480;
  stroke-dashoffset: -460;
  stroke-width: 16px;
  stroke: #ffb6cc;
  cursor: pointer;
}

#logo path {
  stroke-dasharray: 6318;
  stroke-dashoffset: 6318;
  animation: dash 1s linear forwards, fill 1s linear forwards;
  animation-delay: 0s, 1s;
  fill: transparent;
  stroke: #ffb6cc;
}

@keyframes draw {
  0% {
    stroke-dasharray: 140 540;
    stroke-dashoffset: -474;
    stroke-width: 16px;
  }
  100% {
    stroke-dasharray: 760;
    stroke-dashoffset: 0;
    stroke-width: 4px;
  }
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes fill {
  to {
    fill: #999;
  }
}

@keyframes show {
  to {
    opacity: 1;
  }
}
</style>

